import { DateTime } from 'luxon';

import { FORMAT_DATE, FORMAT_DATE_TIME } from './const';
import { ItemType, ScheduleItemType } from './types';

// mapping for direct access to state of visible item by id
export const getMappingIdHideCollapse = (items: ItemType[]) => {
    const mappingIdHideCollapse: { [key: string]: boolean } = {};
    items.forEach((item) => {
        mappingIdHideCollapse[item.id] = item.hideForCollapse || false;
    });
    return mappingIdHideCollapse;
};

// mapping for direct access to item by id
export const getMappingIdIndex = (items: ItemType[]) => {
    const mappingIdIndex: { [key: string]: number } = {};
    items.forEach((item, index) => {
        mappingIdIndex[item.id] = index;
    });
    return mappingIdIndex;
};

//mapping data from server to local type of item
export const transformData = (scheduleItems: ScheduleItemType[]) => {
    return scheduleItems.map((scheduleItem, index): ItemType => {
        const startDateTime = DateTime.fromSQL(scheduleItem.start_datetime);
        const endDateTime = DateTime.fromSQL(scheduleItem.end_datetime);

        const processStringFieldId = (bondName: keyof ScheduleItemType) => {
            return scheduleItem[bondName] && !Array.isArray(scheduleItem[bondName])
                ? (scheduleItem[bondName] as string).split(',')
                : [];
        };

        return {
            id: scheduleItem.id,
            name: scheduleItem.name,
            color: scheduleItem.color,
            type: scheduleItem.type,
            status: scheduleItem.status,
            projectId: scheduleItem.project_id,
            ownerItemId: scheduleItem.owner_item_id || null,
            divisionId: scheduleItem.division_id,
            phaseId: scheduleItem.phase_id,
            costCodeId: scheduleItem.cost_code_id,
            numberWBS: scheduleItem.number_wbs,
            assignee: processStringFieldId('assignee'),
            completionPercentage: Math.round(scheduleItem.completion_percentage),
            idIndex: index,
            startDate: startDateTime.toFormat(FORMAT_DATE),
            endDate: endDateTime.toFormat(FORMAT_DATE),
            countDay: endDateTime.diff(startDateTime, 'days').days + 1,
            children: processStringFieldId('children'),
            parentId: scheduleItem.parent_id,
            bondRight: processStringFieldId('bond_right'),
            bondLeft: processStringFieldId('bond_left'),
            bondParentSS: processStringFieldId('bond_parent_ss'),
            bondParentSE: processStringFieldId('bond_parent_se'),
            bondParentES: processStringFieldId('bond_parent_es'),
            bondParentEE: processStringFieldId('bond_parent_ee'),
            bondSS: processStringFieldId('bond_ss'),
            bondSE: processStringFieldId('bond_se'),
            bondES: processStringFieldId('bond_es'),
            bondEE: processStringFieldId('bond_ee'),
            tasks: scheduleItem.tasks,

            description: scheduleItem.description,
            roleItem: scheduleItem.role_item,
            contractInvoice: scheduleItem.contract_invoice,
            woSi: scheduleItem.wo_si,
            countHours: scheduleItem.count_hours,
            countDays: scheduleItem.count_days,
            countPeople: scheduleItem.count_people,
            countTools: scheduleItem.count_tools,
            countMaterial: scheduleItem.count_material,
            equipmentHours: scheduleItem.equipment_hours,
            materialHours: scheduleItem.material_hours,
            priority: scheduleItem.priority,
            valueEquipment: scheduleItem.value_equipment,
            valueLabour: scheduleItem.value_labour,
            valueMaterial: scheduleItem.value_material,
            valueOther: scheduleItem.value_other,
            valueTotal: scheduleItem.value_total,
        };
    });
};

// mapping local data of item for type of server data
export const transformDataForServer = (listItem: ItemType[]) => {
    return listItem
        .filter((item) => !!item)
        .map((item) => {
            const startDateTime = DateTime.fromISO(item.startDate);
            const endDateTime = DateTime.fromISO(item.endDate);

            const normalizeNumberValue = (value?: number) => {
                return value ? +value : null;
            };

            return <ScheduleItemType>{
                id: item.id,
                name: item.name,
                color: item.color,
                type: normalizeNumberValue(item.type),
                status: normalizeNumberValue(item.status),
                project_id: item.projectId || null,
                owner_item_id: item.ownerItemId || null,
                division_id: normalizeNumberValue(item.divisionId),
                phase_id: normalizeNumberValue(item.phaseId),
                cost_code_id: normalizeNumberValue(item.costCodeId),
                number_wbs: item.numberWBS,
                assignee: item.assignee?.join(','),
                completion_percentage: Math.round(item.completionPercentage),
                children: item.children?.join(','),
                parent_id: item.parentId || null,
                bond_left: item.bondLeft?.join(','),
                bond_right: item.bondRight?.join(','),
                bond_parent_ss: item.bondParentSS?.join(','),
                bond_parent_se: item.bondParentSE?.join(','),
                bond_parent_es: item.bondParentES?.join(','),
                bond_parent_ee: item.bondParentEE?.join(','),
                bond_ss: item.bondSS?.join(','),
                bond_se: item.bondSE?.join(','),
                bond_es: item.bondES?.join(','),
                bond_ee: item.bondEE?.join(','),
                start_datetime: startDateTime.toFormat(FORMAT_DATE_TIME),
                end_datetime: endDateTime.toFormat(FORMAT_DATE_TIME),
                description: item.description,

                role_item: item.roleItem,
                contract_invoice: item.contractInvoice,
                priority: normalizeNumberValue(item.priority),
                wo_si: item.woSi,
                count_hours: normalizeNumberValue(item.countHours),
                count_days: normalizeNumberValue(item.countDays),
                count_people: normalizeNumberValue(item.countPeople),
                count_tools: normalizeNumberValue(item.countTools),
                count_material: normalizeNumberValue(item.countMaterial),
                equipment_hours: normalizeNumberValue(item.equipmentHours),
                material_hours: normalizeNumberValue(item.materialHours),
                value_equipment: normalizeNumberValue(item.valueEquipment),
                value_labour: normalizeNumberValue(item.valueLabour),
                value_material: normalizeNumberValue(item.valueMaterial),
                value_other: normalizeNumberValue(item.valueOther),
                value_total: normalizeNumberValue(item.valueTotal),
            };
        });
};
